/**
 * Единый список иконок для всего приложения
 * Используется в IconPicker, схемах секций и везде где нужен выбор иконок
 *
 * Все иконки проверены на существование в Lucide React
 */

// Основные популярные иконки (показываются первыми)
export const POPULAR_ICONS = [
  'Star', 'Heart', 'Check', 'CheckCircle', 'Zap', 'Shield',
  'Clock', 'MapPin', 'Phone', 'Mail', 'Wifi', 'Coffee',
  'Users', 'Award', 'ThumbsUp', 'Target', 'Rocket', 'Gift',
  'Crown', 'Sparkles', 'Trophy', 'Medal', 'Gem', 'BadgeCheck'
];

// Полный список доступных иконок (Lucide React)
export const ALL_ICONS = [
  // Популярные (дублируются для порядка)
  'Star', 'Heart', 'Check', 'CheckCircle', 'Zap', 'Shield',
  'Clock', 'MapPin', 'Phone', 'Mail', 'Wifi', 'Coffee',
  'Users', 'Award', 'ThumbsUp', 'Target', 'Rocket', 'Gift',
  'Crown', 'Sparkles', 'Trophy', 'Medal', 'Gem', 'BadgeCheck',

  // Навигация и действия
  'Home', 'Search', 'Settings', 'Bell', 'Calendar', 'Camera',
  'Edit', 'Trash2', 'Plus', 'Minus', 'Eye', 'EyeOff', 'Lock', 'Unlock',
  'Download', 'Upload', 'Send', 'Share2', 'ExternalLink', 'Link',

  // Коммуникация
  'MessageCircle', 'MessageSquare', 'MessagesSquare', 'AtSign',

  // Бизнес и финансы
  'Briefcase', 'CreditCard', 'DollarSign', 'Wallet', 'Receipt',
  'TrendingUp', 'TrendingDown', 'BarChart', 'PieChart', 'Activity',

  // Люди
  'User', 'UserCheck', 'UserPlus', 'UserCircle',

  // Устройства
  'Laptop', 'Monitor', 'Smartphone', 'Tablet', 'Headphones',

  // Файлы и документы
  'File', 'FileText', 'Folder', 'ClipboardList', 'BookOpen', 'Notebook',

  // Медиа
  'Image', 'Video', 'Music', 'Play', 'Pause', 'Volume2',

  // Природа и погода
  'Sun', 'Moon', 'Cloud', 'Leaf', 'Flower2', 'Mountain',

  // Транспорт
  'Car', 'Plane', 'Ship',

  // Еда
  'UtensilsCrossed', 'Wine', 'Beer',

  // Здания
  'Building', 'Building2', 'Store', 'Warehouse',

  // Покупки
  'ShoppingCart', 'ShoppingBag', 'Package', 'Tag',

  // Инструменты
  'Wrench', 'Hammer', 'Scissors', 'Paintbrush', 'Pen', 'Pencil',

  // Стрелки
  'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown',
  'ChevronRight', 'ChevronLeft', 'ChevronUp', 'ChevronDown',

  // Формы
  'Circle', 'Square', 'Triangle', 'Hexagon',

  // Разное
  'Lightbulb', 'Flag', 'Bookmark', 'Globe', 'Compass', 'Map',
  'Key', 'QrCode', 'Fingerprint', 'Scan',
  'Power', 'Battery', 'Plug', 'Cpu', 'Database', 'Server', 'HardDrive',
  'RefreshCw', 'RotateCw', 'Repeat', 'Shuffle',
  'Maximize', 'Minimize', 'Move', 'Crop',
  'Hash', 'Percent', 'Info', 'HelpCircle', 'AlertCircle', 'AlertTriangle',
  'XCircle', 'CheckCircle2', 'CircleDot',

  // Социальные сети (для Contact)
  'Facebook', 'Instagram', 'Linkedin', 'Twitter', 'Youtube', 'Github'
];

// Иконки для контактов
export const CONTACT_ICONS = [
  'Phone', 'Mail', 'MapPin', 'Clock', 'Globe', 'MessageCircle'
];

// Иконки социальных сетей (Send используется как Telegram)
export const SOCIAL_ICONS = [
  'Facebook', 'Instagram', 'Linkedin', 'Twitter', 'Youtube', 'Github', 'Send', 'MessageCircle'
];

// Экспорт по умолчанию - популярные иконки
export default POPULAR_ICONS;
